// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"D3-z","colorTextValue":"E3-z","swatches":"F3-z","collapseLink":"G3-z","isCollapsed":"H3-z","dropdown":"I3-z","disabled":"J3-z"};